import React, { useCallback, useContext } from 'react';
import { useRecoilState } from 'recoil';
import { useHistory, useUrlBuilder } from '@app/router';
import { EditListModalContext } from '@account/pages/Favorites/context';
import ListEditForm from '.';
import listInfo from '../../../state/listInfoState';
import { useEditList, useRemoveList } from '../hooks';
import { useList } from '../../../hooks';

interface FormChanges {
  name?: string;
  public?: boolean;
}

const ListEditFormWrapper = () => {
  const { setOnUpdated, onToggle } = useContext(EditListModalContext);

  const [{ id }, setListInfo] = useRecoilState(listInfo);
  const { data } = useList(id);

  const history = useHistory();
  const buildUrl = useUrlBuilder();
  const { updateList, isLoading, error: submitError } = useEditList();
  const { removeList, isLoading: isDeleting } = useRemoveList();

  const handleSubmit = useCallback(
    async (changes: FormChanges) => {
      if (isLoading) {
        return;
      }

      await updateList({
        input: {
          id,
          changes,
        },
      });

      if (setOnUpdated) {
        setOnUpdated(true);
      }

      onToggle();

      setListInfo((prev) => ({
        ...prev,
        update: true,
      }));
    },
    [id, isLoading, onToggle, setListInfo, setOnUpdated, updateList],
  );

  const handleDeleteList = useCallback(async () => {
    if (isDeleting) {
      return;
    }

    const data = await removeList({
      input: {
        id,
      },
    });

    const { name = '', public: isPublic = false } =
      data?.removeList?.list ?? {};

    const url = buildUrl('/favorites');

    history.push(
      `${url}/?name=${encodeURIComponent(name ?? '')}&public=${isPublic}`,
    );
  }, [buildUrl, removeList, history, id, isDeleting]);

  return (
    <ListEditForm
      handleSubmit={handleSubmit}
      handleDeleteList={handleDeleteList}
      submitError={submitError}
      currentData={{
        listName: data?.listName ?? '',
        public: data?.public ?? false,
      }}
    />
  );
};

export default ListEditFormWrapper;
